export default 1/2.54
